import { stdObject } from "../data/types/stdObject";

const compareValues = (a: any, b: any) => {
  if (typeof a === "number" && typeof b === "number") {
    return a - b;
  }
  return String(a ?? "").localeCompare(String(b ?? ""));
};

export const sortGroup = (data: stdObject[], group: string, order: string) => {
  return [...data].sort((a: stdObject, b: stdObject) => {
    if (a[group] !== b[group]) {
      return compareValues(a[group], b[group]);
    }
    return compareValues(a[order], b[order]);
  });
};
